import api from "../../../services/api"
import mockApi from "./nfePipeline.mock"

const BASE_PATH = (process.env.REACT_APP_NFE_PIPELINE_BASE || "/nfe-pipeline").replace(/\/$/, "")
const MOCK_ENABLED = process.env.REACT_APP_NFE_PIPELINE_MOCK === "true"

function buildUrl(path) {
  return BASE_PATH + path
}

function extractFilename(headers, fallback) {
  const disposition = headers && headers["content-disposition"]
  if (!disposition) return fallback
  const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/)
  if (utfMatch && utfMatch[1]) {
    return decodeURIComponent(utfMatch[1])
  }
  const match = disposition.match(/filename="?([^"]+)"?/)
  if (match && match[1]) {
    return match[1]
  }
  return fallback
}

async function withFallback(action, fallback) {
  if (MOCK_ENABLED) {
    return fallback()
  }
  return action()
}

export async function listRuns(params) {
  return withFallback(
    () => api.get(buildUrl("/runs/"), { params: params }).then((response) => response.data),
    () => mockApi.listRuns(params),
  )
}

export async function getRun(runId) {
  return withFallback(
    () => api.get(buildUrl("/runs/" + runId + "/")).then((response) => response.data),
    () => mockApi.getRun(runId),
  )
}

export async function createRun(file, mode, limit, options) {
  return withFallback(
    () => {
      const formData = new FormData()
      formData.append("file", file)
      formData.append("mode", mode)
      if (limit) {
        formData.append("limit", limit)
      }
      if (options) {
        if (typeof options.dry_run === "boolean") {
          formData.append("dry_run", options.dry_run ? "true" : "false")
        }
        if (typeof options.import_enabled === "boolean") {
          formData.append("import_enabled", options.import_enabled ? "true" : "false")
        }
        if (options.import_ref) {
          formData.append("import_ref", options.import_ref)
        }
      }

      return api
        .post(buildUrl("/runs/"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => response.data)
    },
    () => mockApi.createRun(file, mode, limit, options),
  )
}

export async function pauseRun(runId) {
  return withFallback(
    () => api.post(buildUrl("/runs/" + runId + "/pause/")).then((response) => response.data),
    () => mockApi.pauseRun(runId),
  )
}

export async function resumeRun(runId) {
  return withFallback(
    () => api.post(buildUrl("/runs/" + runId + "/resume/")).then((response) => response.data),
    () => mockApi.resumeRun(runId),
  )
}

export async function getTemplate(mode) {
  return withFallback(
    () => api.get(buildUrl("/runs/templates/" + mode + "/")).then((response) => response.data),
    () => mockApi.getTemplate(mode),
  )
}

export async function downloadTemplate(mode) {
  return withFallback(
    () =>
      api
        .get(buildUrl("/runs/templates/" + mode + "/") + "?download=true", {
          responseType: "blob",
        })
        .then((response) => ({
          blob: response.data,
          filename: extractFilename(response.headers, mode + "_template.xlsx"),
        })),
    () => mockApi.downloadTemplate(mode),
  )
}

export async function downloadDocs(runId) {
  return withFallback(
    () =>
      api
        .get(buildUrl("/runs/" + runId + "/download-docs/"), {
          responseType: "blob",
        })
        .then((response) => ({
          blob: response.data,
          filename: extractFilename(response.headers, "nfe_docs.zip"),
        })),
    () => mockApi.downloadDocs(runId),
  )
}

export async function downloadCompleto(runId) {
  return withFallback(
    () =>
      api
        .get(buildUrl("/runs/" + runId + "/download-completo/"), {
          responseType: "blob",
        })
        .then((response) => ({
          blob: response.data,
          filename: extractFilename(response.headers, "nfe_completo.zip"),
        })),
    () => mockApi.downloadCompleto(runId),
  )
}

export async function getRequiredColumns(mode) {
  return withFallback(
    () => api.get(buildUrl("/runs/required-columns/"), { params: { mode: mode } }).then((response) => response.data),
    () => mockApi.getRequiredColumns(mode),
  )
}

export async function listItems(params) {
  return withFallback(
    () => api.get(buildUrl("/items/"), { params: params }).then((response) => response.data),
    () => mockApi.listItems(params),
  )
}

export async function listEvents(params) {
  return withFallback(
    () => api.get(buildUrl("/events/"), { params: params }).then((response) => response.data),
    () => mockApi.listEvents(params),
  )
}

export async function listFiles(params) {
  return withFallback(
    () => api.get(buildUrl("/files/"), { params: params }).then((response) => response.data),
    () => mockApi.listFiles(params),
  )
}

export async function listNotifications(params) {
  return withFallback(
    () => api.get(buildUrl("/notifications/"), { params: params }).then((response) => response.data),
    () => mockApi.listNotifications(params),
  )
}

export async function listEmitidas(params) {
  return withFallback(
    () => api.get(buildUrl("/emitidas/"), { params: params }).then((response) => response.data),
    () => mockApi.listEmitidas(params),
  )
}

export async function markNotificationRead(notificationId) {
  return withFallback(
    () => api.post(buildUrl("/notifications/" + notificationId + "/mark-read/")).then((response) => response.data),
    () => mockApi.markNotificationRead(notificationId),
  )
}



// WEBPACK FOOTER //
// ./src/components/NFePipeline/services/nfePipeline.service.js